import { H } from 'highlight.run';
import { ErrorBoundary } from '@highlight-run/react';
import React from 'react';
import { HighlightConfig } from './highlightConfig';
import { getApplicationEnv } from '../env';

export interface HighlightInstance {
    initialize(): void;
    ErrorBoundary: React.ComponentType<{ children?: React.ReactNode }>;
}

/**
 * Creates a Highlight instance. If config is null, returns a no-op instance
 * that skips initialization but provides a passthrough ErrorBoundary.
 */
export function createHighlight(config: HighlightConfig | null): HighlightInstance {
    if (!config) {
        return {
            initialize() {
                console.info('[Highlight] Project ID not configured, skipping initialization');
            },
            // Passthrough component when Highlight is disabled
            ErrorBoundary: ({ children }) => React.createElement(React.Fragment, null, children),
        };
    }

    return {
        initialize() {
            const environment = getApplicationEnv();
            if (process.env.VAROS_ENV !== 'production') {
                console.info(`[Highlight] Skipping initialization in '${environment}' environment`);
                return;
            }
            H.init(config.projectId, {
                serviceName: 'client',
                environment,
                tracingOrigins: true,
                reportConsoleErrors: true,
                privacySetting: 'none',
                networkRecording: {
                    enabled: true,
                    recordHeadersAndBody: true,
                    urlBlocklist: [],
                },
            });
        },
        ErrorBoundary,
    };
}
